import { useEffect, useRef, useState } from 'react';

const MAX_RETRIES = 20;
const POLLING_INTERVAL = 250;

export const useHubSpotApiLoader = () => {
  const intervalId = useRef<number>(0);
  const retryCount = useRef(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Poll for HubSpot API availability every 250ms
    intervalId.current = window.setInterval(() => {
      // Check if HubSpot forms API is available
      if (window.hbspt?.forms?.create) {
        setIsLoaded(true);
        window.clearInterval(intervalId.current);
        return;
      }
      
      // Increment retry counter
      retryCount.current += 1;
      
      // Stop polling after maximum retries
      if (retryCount.current >= MAX_RETRIES) {
        console.error('Hubspot API not loaded after maximum retries.');
        window.clearInterval(intervalId.current);
      }
    }, POLLING_INTERVAL);

    // Cleanup interval on unmount
    return () => {
      window.clearInterval(intervalId.current);
    };
  }, []);

  return { isLoaded };
}; 
